import 'angular';

import { LoginCtrl }       from './login.ajs';
import { LoginServiceAjs } from './login.service.ajs';

angular.module('app.login', [])
  .controller('LoginCtrl', LoginCtrl)
  .service('loginApi', LoginServiceAjs);
